<template>
  <el-dialog
    title="裁剪图片"
    width="800px"
    :visible.sync="visible"
    @opened="handleOpened"
    @close="handleClose">
    <div v-show="imgUrl" class="btns">
        <div>推荐尺寸：</div>
        <el-button @click="setRecommend">{{ recommendSize.join('x') }}</el-button>
    </div>
    <div v-loading="!imgUrl && visible" class="crop-wrap">
        <div v-show="imgUrl" :style="[cropAreaSizeStyle]" class="crop-img">
            <div class="crop-label">
                剪裁区：
                <el-button type="link" icon="el-icon-zoom-in" @click="zoomClick('in')"></el-button>
                <el-button type="link" icon="el-icon-zoom-out" @click="zoomClick('out')"></el-button>
                <span class="new-tip">(支持鼠标滚轮缩放图片)</span>
            </div>
            <img id="cropImg" v-if="imgUrl" :src="imgUrl" />
        </div>
        <div v-show="imgUrl" class="crop-preview">
            <div class="crop-label">
                <!-- 预览区：
                <span style="color:#a3a3a3; font-size:12px;">{{ preViewTips }}</span> -->
            </div>
             <div class="tool-btns">
            </div>
            <div class="crop-preview-img"></div>
            <div class="crop-preview-text">
                预览图像素： {{ previewPixText }}
            </div>
        </div>
    </div>

    <template slot="footer">
        <span>
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="handleOk">确定</el-button>
        </span>
    </template>

  </el-dialog>
</template>

<script>
/** 图片裁剪操作弹窗组件 **/
/**
 * 对外提供method_open方法
 * 方法参数（url, opts）
 * url: 图片地址
 * opts: 其他设置
 */
import { getBase64 } from '@/api/base/index.js'
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css'
export default {
    name: "cropDialog",
    data() {
        return {
            visible: false,
            imgUrl: "",
            fileType: "",
            cropper: null,
            detail: {},
            cropAreaSize: [400, 400],
            recommendSize: [800, 800],
            minSize: [50, 50],
            maxSize: [2000, 2000]
        }
    },
    computed: {
        previewPixText() {
            if (this.detail.width && this.detail.height) {
                return `${this.detail.width.toFixed(0)} X ${this.detail.height.toFixed(0)}`
            } else {
                return ''
            }
        },
        cropAreaSizeStyle() {
            const [width, height] = this.cropAreaSize
            return {
                width: `${width}px`,
                height: `${height}px`,
            }
        },
        // preViewTips() {
        //     return `最小限制${this.minSize[0]}x${this.minSize[1]}，最大限制${this.maxSize[0]}x${this.maxSize[1]}`
        // }
    },
    methods: {
        close() {
            this.visible = false
        },
        handleOk() {
            // if (!this.isSafeSize()) {
            //     return ;
            // }
            let type = this.fileType === 'png' ? 'image/png' : 'image/jpeg';
            this.cropper.getCroppedCanvas({ fillColor: '#fff' }).toBlob((blob) => {
                const file = new File([blob], `clip.${this.fileType}`)
                this.$emit('success', file)
                this.visible = false
            }, type)
        },
        handleOpened() {
            
        },
        handleClose() {
            this.imgUrl = "";
            this.fileType = "";
            this.cropper && this.cropper.destroy();
            this.cropper = null;
        },
        isSafeSize(backFn) {
            const {width, height} = this.detail
            const [minW, minH] = this.minSize
            const [maxW, maxH] = this.maxSize

            const comfirmFn = (msg) => {
                this.$alert(msg, '提示', { center: true }).then(() => {
                    backFn && backFn()
                }).catch(() => {
                    backFn && backFn()
                })
            }

            if (width > maxW) {
                comfirmFn(`宽度超出${maxW}`)
                return false
            }
            if (width < minW) {
                comfirmFn(`宽度小于${minW}`)
                return false
            }
            if (height > maxH) {
                comfirmFn(`高度超出${maxH}`)
                return false
            }
            if (height < minH) {
                comfirmFn(`高度小于${minH}`)
                return false
            }
            return true
        },
        // 推荐尺寸回调
        setRecommend() {
            this.cropper.reset();
            this.parseImageData();
        },
        zoomClick(type) {
            switch(type) {
                case 'in':
                    this.cropper.zoom(0.1);
                    // this.isSafeSize(() => {
                    //     this.cropper.zoom(-0.1);
                    // })
                    break;
                case 'out':
                    this.cropper.zoom(-0.1);
                    // this.isSafeSize(() => {
                    //     this.cropper.zoom(0.1);
                    // })
                    break;
                default: ;
            }
        },
        init_crop() {
            const img = document.querySelector('#cropImg')
            const vm = this;
            this.cropper = new Cropper(img, {
                initialAspectRatio: this.recommendSize[0] / this.recommendSize[1],
                preview: ".crop-preview-img",
                rotatable: false,
                autoCrop: false,
                checkOrientation: false,
                zoomOnTouch: false,
                zoomOnWheel: true,
                scalable: false,
                rotatable: false,
                toggleDragModeOnDblclick: false,
                dragMode: "move",
                ready: () => {
                    this.cropper.crop()
                    this.parseImageData()
                },
                crop(event) {
                    vm.detail = event.detail;
                }
            });
        }, 
        /**
         * 解析图片数据
         * 将裁剪框调整值推荐尺寸大小
         */
        parseImageData() {
            const imgData = this.cropper.getImageData();
            const data = this.cropper.getData();
            const {naturalHeight, naturalWidth, height, width} = imgData
            const [recommendWidth, recommendHeight] = this.recommendSize
            let ratio = 1 // 在初始比例上的需要
            let initRatio = 1 // 初始加载后的比例
            if (naturalHeight > naturalWidth) {
                initRatio = naturalHeight / height
                ratio = data.height / recommendHeight
            } else {
                initRatio = naturalWidth / width
                ratio = data.width / recommendWidth
            }
            this.cropper.zoomTo(ratio / initRatio)
        },

        // 后续替换为后端转base64,解决跨域问题
        async getBase64(url, cb) {
            const match = url.match(/.*\.([^?]*)/)
            const fileType = match[1];

            const prefix = `data:image/${fileType};base64,`

            let res = await getBase64(url, { isNeedLoading: false })
            if (res.result === 1) {
                cb && cb(`${prefix}${res.data}`, fileType);
            }
        },
        method_open(url, opts = {}) {
            this.visible = true;
            this.recommendSize = opts.recommendSize || [800, 800];
            this.getBase64(url, (base64url, fileType) => {
                this.imgUrl = base64url  
                this.fileType = fileType
                this.$nextTick(() => {
                    this.init_crop()
                })
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.btns {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}
.crop-wrap {
    min-height: 430px;

    .crop-label {
        height: 28px;
        margin-bottom: 5px;
        display: flex;
        align-items: center;
        & ::v-deep button {
            padding: 0 10px;
            margin: 0;
            font-size: 16px;
        }
    }

    .crop-img {
        margin-right: 10px;
        img {
            max-width: 400px;
            max-height: 400px;
        }
        float: left;
    }
    .crop-preview {
        float: left;
        width: 300px;
        height: 400px;
        .crop-preview-img {
            height: 300px;
            width: 300px;
            overflow: hidden;
        }
        .crop-preview-text {
            margin-top: 10px;
        }
    }
}
</style>